const types = {
  USER_AUTH_UPDATE: 'USER_AUTH_UPDATE',
  USER_SIGN_OUT: 'USER_SIGN_OUT',
  USER_ADD_ROLE: 'USER_ADD_ROLE',
  USER_UPDATE_ROLES: 'USER_UPDATE_ROLES',
  USER_REMOVE_ROLE: 'USER_REMOVE_ROLE',
  USER_ADD_PRACTICE: 'USER_ADD_PRACTICE',
  USER_UPDATE_INFO: 'USER_UPDATE_INFO',
  USER_ADD_USER: 'USER_ADD_USER',
  USER_NOTIFICATION_PREFERENCES_UPDATE: 'USER_NOTIFICATION_PREFERENCES_UPDATE',
  USER_DISPLAYED_TOLSTOY_COUNT_UPDATE: 'USER_DISPLAYED_TOLSTOY_COUNT_UPDATE',

  CONTEXT_UPDATE_PRACTICE: 'CONTEXT_UPDATE_PRACTICE',
  CONTEXT_UPDATE_ROLE: 'CONTEXT_UPDATE_ROLE',
  CONTEXT_UPDATE_LOCATION: 'CONTEXT_UPDATE_LOCATION',

  EMG_INSTANT_SESSIONS_UPDATE: 'EMG_INSTANT_SESSIONS_UPDATE',
  EMG_SESSIONS_STATUS_DICT_UPDATE: 'EMG_SESSIONS_STATUS_DICT_UPDATE',

  INSTANT_PRACTICE_UPDATE: 'INSTANT_PRACTICE_UPDATE',
  INSTANT_LOCATION_UPDATE: 'INSTANT_LOCATION_UPDATE',
  INSTANT_STATUS_DICT_UPDATE: 'INSTANT_STATUS_DICT_UPDATE',
  INSTANT_DICT_UPDATE: 'INSTANT__DICT_UPDATE',
  INSTANT_UPDATE_NON_COMPLETED_IDS: 'INSTANT_UPDATE_NON_COMPLETED_IDS',
  INSTANT_UPDATE_COMPLETED_IDS: 'INSTANT_UPDATE_COMPLETED_IDS',
  INSTANT_COMPLETED_CANCELLED_IDS_UPDATE: 'INSTANT_COMPLETED_CANCELLED_IDS_UPDATE',
  INSTANT_DICT_UPDATE_ITEM: 'INSTANT_DICT_UPDATE_ITEM',
  INSTANT_UPDATE_PAGE_STATE: 'INSTANT_UPDATE_PAGE_STATE',
  INSTANT_UPDATE_DISPLAY_VALIDATION: 'INSTANT_UPDATE_DISPLAY_VALIDATION',
  INSTANT_CLEAR_DATA: 'INSTANT_CLEAR_DATA',

  PRACTICE_INFO_UPDATE: 'PRACTICE_INFO_UPDATE',
  PRACTICE_LOCATIONS_UPDATE: 'PRACTICE_LOCATIONS_UPDATE',
  PRACTICE_LOCATION_ADD: 'PRACTICE_LOCATION_ADD',
  PRACTICE_LOCATION_MEMBERS_ADD: 'PRACTICE_LOCATION_MEMBERS_ADD',
  PRACTICE_LOCATIONS_DETAILS_SELECT: 'PRACTICE_LOCATIONS_DETAILS_SELECT',
  PRACTICE_JOIN_REQUESTS_UPDATE: 'PRACTICE_JOIN_REQUESTS_UPDATE',
  PRACTICE_USER_ROLE_ADD: 'PRACTICE_USER_ROLE_ADD',
  PRACTICE_USER_ROLE_UPDATE: 'PRACTICE_USER_ROLE_UPDATE',
  PRACTICE_EDIT_LOCATION_UPDATE: 'PRACTICE_EDIT_LOCATION_UPDATE',
  PRACTICE_ACTIVE_CONSULTATIONS_UPDATE: 'PRACTICE_ACTIVE_CONSULTATIONS_UPDATE',
  PRACTICE_RESOLVED_CONSULTATIONS_UPDATE: 'PRACTICE_RESOLVED_CONSULTATIONS_UPDATE',
  PRACTICE_PROCESSING_CONSULTATIONS_UPDATE: 'PRACTICE_PROCESSING_CONSULTATIONS_UPDATE',
  PRACTICE_ADD_PATIENT: 'PRACTICE_ADD_PATIENT',
  PRACTICE_PATIENTS_UPDATE: 'PRACTICE_PATIENTS_UPDATE',
  PRACTICE_STAFF_UPDATE: 'PRACTICE_STAFF_UPDATE',
  PRACTICE_STAFF_MEMBER_SELECTED_UPDATE: 'PRACTICE_STAFF_MEMBER_SELECTED_UPDATE',
  PRACTICE_STAFF_MEMBER_SELECTED_ROLES_UPDATE: 'PRACTICE_STAFF_MEMBER_SELECTED_ROLES_UPDATE',
  PRACTICE_STAFF_MEMBER_SELECTED_LOCATIONS_UPDATE: 'PRACTICE_STAFF_MEMBER_SELECTED_LOCATIONS_UPDATE',
  PRACTICE_UPDATE_BANK: 'PRACTICE_UPDATE_BANK',
  PRACTICE_FRONT_DESK_SELECT: 'PRACTICE_FRONT_DESK_SELECT',
  PRACTICE_CLIENTS_UPDATE: 'PRACTICE_CLIENTS_UPDATE',
  PRACTICE_SELECTED_UNASSIGNED_CLIENT: 'PRACTICE_SELECTED_UNASSIGNED_CLIENT',
  PRACTICE_FRONT_DESK_USERS_UPDATE: 'PRACTICE_FRONT_DESK_USERS_UPDATE',
  PRACTICE_FRONT_DESK_TASKS_UPDATE: 'PRACTICE_FRONT_DESK_TASKS_UPDATE',
  PRACTICE_UPDATE_ALERTS: 'PRACTICE_UPDATE_ALERTS',
  PRACTICE_UPDATE_NOTIFICATION_PREFERENCES: 'PRACTICE_UPDATE_NOTIFICATION_PREFERENCES',
  PRACTICE_UPDATE_STRIPE: 'PRACTICE_UPDATE_STRIPE',
  PRACTICE_UPDATE_STRIPE_VERIFICATION_LINK: 'PRACTICE_UPDATE_STRIPE_VERIFICATION_LINK',
  PRACTICE_UPDATE_STRIPE_UPDATE_LINK: 'PRACTICE_UPDATE_STRIPE_UPDATE_LINK',
  PRACTICE_UNASSIGNED_CONSULTATIONS_UPDATE: 'PRACTICE_UNASSIGNED_CONSULTATIONS_UPDATE',
  PRACTICE_PROVIDER_LOCATION_DICT_UPDATE: 'PRACTICE_PROVIDER_LOCATION_DICT_UPDATE',
  PRACTICE_PROVIDER_LOCATION_DICT_ADD: 'PRACTICE_PROVIDER_LOCATION_DICT_ADD',
  PRACTICE_CLIENT_PAGE_STATE_UPDATE: 'PRACTICE_CLIENT_PAGE_STATE_UPDATE',
  PRACTICE_UPDATE_PRACTICE: 'PRACTICE_UPDATE_PRACTICE',
  PRACTICE_UPDATE_PRACTICE_SUBSCRIPTION: 'PRACTICE_UPDATE_PRACTICE_SUBSCRIPTION',
  PRACTICE_PROVIDER_PAGE_STATE_UPDATE: 'PRACTICE_PROVIDER_PAGE_STATE_UPDATE',

  CONSULTATION_SELECTED_UPDATE: 'CONSULTATION_SELECTED_UPDATE',
  CONSULTATION_UPDATE_PARTICIPANTS: 'CONSULTATION_UPDATE_PARTICIPANTS',
  CONSULTATION_ADD_CONSULTATION_DETAIL: 'CONSULTATION_ADD_CONSULTATION_DETAIL',
  CONSULTATION_SELECTED_TAB: 'CONSULTATION_SELECTED_TAB',
  CONSULTATION_UPDATE_CONSULTATION_TASKS: 'CONSULTATION_UPDATE_CONSULTATION_TASKS',
  CONSULTATION_UPDATE_CONSULTATION_RECORDS: 'CONSULTATION_UPDATE_CONSULTATION_RECORDS',
  CONSULTATIONS_SCREEN_STATE_UPDATE: 'CONSULTATIONS_SCREEN_STATE_UPDATE',
  CONSULTATION_UPDATE_INFO: 'CONSULTATION_UPDATE_INFO',
  CONSULTATIONS_CLEAR_DATA: 'CONSULTATIONS_CLEAR_DATA',
  CONSULTATION_UPDATE_PREVIEWS: 'CONSULTATION_UPDATE_PREVIEWS',
  CONSULTATION_UPDATE_SEE_ALL: 'CONSULTATION_UPDATE_SEE_ALL',
  CONSULTATION_UPDATE_SEE_ALL_STATUS: 'CONSULTATION_UPDATE_SEE_ALL_STATUS',
  CONSULTATION_UPDATE_SEE_ALL_PAGE_STATE: 'CONSULTATION_UPDATE_SEE_ALL_PAGE_STATE',

  NOTIFICATIONS_UPDATE_DICT: 'NOTIFICATIONS_UPDATE_DICT',
  NOTIFICATIONS_UPDATE_TYPE_DICT: 'NOTIFICATIONS_UPDATE_TYPE_DICT',
  NOTIFICATIONS_UPDATE_CONSULTATIONS_DICT: 'NOTIFICATIONS_UPDATE_CONSULTATIONS_DICT',
  NOTIFICATIONS_UPDATE_CONSULTATIONS_SOCKET: 'NOTIFICATIONS_UPDATE_CONSULTATIONS_SOCKET',

  LOADING_USER_PROFILE_EDIT: 'LOADING_USER_PROFILE_EDIT',
  LOADING_SEARCH_PRACTICE_CODE: 'LOADING_SEARCH_PRACTICE_CODE',
  LOADING_CREATE_NEW_PRACTICE: 'LOADING_CREATE_NEW_PRACTICE',
  LOADING_ADD_EDIT_LOCATION: 'LOADING_ADD_EDIT_LOCATION',
  LOADING_ADD_EDIT_FRONT_DESK: 'LOADING_ADD_EDIT_FRONT_DESK',
  LOADING_SAVE_BANK: 'LOADING_SAVE_BANK',
  LOADING_SET_BANK_COMPANY: 'LOADING_SET_BANK_COMPANY',
  LOADING_RESOLVE_CONSULTATION: 'LOADING_RESOLVE_CONSULTATION',
  LOADING_CHANGE_PASSWORD: 'LOADING_CHANGE_PASSWORD',
  LOADING_SAVE_APPOINTMENT: 'LOADING_SAVE_APPOINTMENT',

  SCHEDULE_UPDATE_PRACTICE_APT_IDS: 'SCHEDULE_UPDATE_PRACTICE_APT_IDS',
  SCHEDULE_UPDATE_PRACTICE_ALL_APT_IDS: 'SCHEDULE_UPDATE_PRACTICE_ALL_APT_IDS',
  SCHEDULE_ADD_PRACTICE_ALL_APT_ID: 'SCHEDULE_ADD_PRACTICE_ALL_APT_ID',
  SCHEDULE_ADD_PRACTICE_APT_ID: 'SCHEDULE_ADD_PRACTICE_APT_ID',
  SCHEDULE_UPDATE_APT_DICT: 'SCHEDULE_UPDATE_APT_DICT',
  SCHEDULE_ADD_APT_TO_DICT: 'SCHEDULE_ADD_APT_TO_DICT',
  SCHEDULE_ADD_APT_TO_CONSULT_DICT: 'SCHEDULE_ADD_APT_TO_CONSULT_DICT',
  SCHEDULE_UPDATE_CONSULT_DICT: 'SCHEDULE_UPDATE_CONSULT_DICT',
  SCHEDULE_UPDATE_USER_ALL_APT_IDS: 'SCHEDULE_UPDATE_USER_ALL_APT_IDS',
  SCHEDULE_ADD_USER_ALL_APT_ID: 'SCHEDULE_ADD_USER_ALL_APT_ID',
  SCHEDULE_UPDATE_USER_APT_IDS: 'SCHEDULE_UPDATE_USER_APT_IDS',
  SCHEDULE_ADD_USER_APT_ID: 'SCHEDULE_ADD_USER_APT_ID',
}

export default types;
